// Configuration for Donexus Outlook Add-in

const isDevelopment = process.env.NODE_ENV !== 'production';

const DEFAULTS = {
  API_BASE_URL: isDevelopment
    ? 'http://localhost:3001/api'
    : 'https://donexus-js-366314214496.europe-west3.run.app/api',
  BACKEND_URL: isDevelopment
    ? 'http://localhost:3001'
    : 'https://donexus-js-366314214496.europe-west3.run.app',
  APP_BASE_URL: isDevelopment
    ? 'http://localhost:3000'
    : 'https://app.donexus.de',
};

const config = {
  // API Configuration
  API_BASE_URL: process.env.API_BASE_URL || DEFAULTS.API_BASE_URL,
  BACKEND_URL: process.env.BACKEND_URL || DEFAULTS.BACKEND_URL,

  // Auth API base
  AUTH_BASE_URL: `${process.env.API_BASE_URL || DEFAULTS.API_BASE_URL}/auth`,

  // Web app base (used for deep-links opened in a new tab)
  APP_BASE_URL: process.env.APP_BASE_URL || DEFAULTS.APP_BASE_URL,

  // Other configuration values
  SOCKET_PATH: '/socket.io',
  ENABLE_LOGGING: isDevelopment,
};

export default config;

